module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_null.c9501e3f.png";